import { useTranslation } from 'react-i18next'

import { Badge, ColorSwatch, Flex, Typography } from '@percent/lemonade'
import type { GivingHomePageBannerContentConfigValue } from '@percent/admin-dashboard/api/types'

type BannerContentDisplayProps = { data: GivingHomePageBannerContentConfigValue }

export function BannerContentDisplay({ data }: BannerContentDisplayProps) {
  const { t } = useTranslation()

  return (
    <Flex direction="column" gap={4} align="flex-end">
      <Flex align="center" gap={1}>
        <Typography variant="small" $color="gray600">
          {t('partnerConfig.branding.welcomeCopy')}
        </Typography>
        <Badge variant={data.welcomeCopy ? 'positive' : 'default'}>
          {data.welcomeCopy ? t('typography.enabled') : t('typography.disabled')}
        </Badge>
      </Flex>
      <Flex align="center" gap={1}>
        <Typography variant="small" $color="gray600">
          {t('partnerConfig.branding.searchBar')}
        </Typography>
        <Badge variant={data.searchBar ? 'positive' : 'default'}>
          {data.searchBar ? t('typography.enabled') : t('typography.disabled')}
        </Badge>
      </Flex>
      {data.welcomeCopyTitle && (
        <Typography variant="small" $color="gray600">
          {t('partnerConfig.branding.title', { value: data.welcomeCopyTitle })}
        </Typography>
      )}
      {data.welcomeCopySubtitle && (
        <Typography variant="small" $color="gray600">
          {t('partnerConfig.branding.subtitle', { value: data.welcomeCopySubtitle })}
        </Typography>
      )}
      {data.welcomeCopyColor && (
        <Flex align="center" gap={2}>
          <Typography variant="small" $color="gray600">
            {t('partnerConfig.branding.copyColor')}
          </Typography>
          <ColorSwatch color={data.welcomeCopyColor} size={16} radius="sm" />
          <Typography variant="small" $color="gray500">
            {data.welcomeCopyColor}
          </Typography>
        </Flex>
      )}
    </Flex>
  )
}
